<div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start center"
>
    <div>
        <mat-list>
            <mat-list-item>
                <h3 matLine>Banco</h3>
                <p matLine>
                    <span class="text-bold">{{
                        contratista.banco.nombre
                    }}</span>

                    <button
                        *ngIf="_menuUsuarioSrvc.esSupervisor() && !eliminado"
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="dialogActualizar()"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </p>
            </mat-list-item>

            <mat-list-item>
                <h3 matLine>Tipo Cuenta</h3>
                <p matLine>
                    <span class="secondary-text">{{
                        contratista.tipoCuenta.descripcion
                    }}</span>
                </p>
            </mat-list-item>

            <mat-list-item>
                <h3 matLine>Nro. de cuenta</h3>
                <p matLine>
                    <span class="secondary-text">{{
                        contratista.numeroCuenta
                    }}</span>
                </p>
            </mat-list-item>
        </mat-list>
    </div>
</div>
